import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: true,
  clientVersion: '1.81.0-130-g65e17d41',
  logLevel: NgxLoggerLevel.INFO,
  API_HOST: 'https://' + window.location.hostname
};
